import { History } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShellBar } from "@/components/layout/ShellBar";

interface WorkbenchHeaderBarProps {
  projectId: string;
  projectName: string;
  runCount?: number;
}

export function WorkbenchHeaderBar({ projectId, projectName, runCount = 0 }: WorkbenchHeaderBarProps) {
  const { t } = useTranslation();
  return (
    <ShellBar
      breadcrumbs={[
        { label: t("Projects"), to: "/projects" },
        { label: projectName, to: `/projects/${projectId}` },
        { label: "Functional" },
      ]}
      actions={
        // Sem "New Run" aqui (#1042): o do hero abre o mesmo formulário e é o
        // único que sabe do escopo aprovado.
        <Button
          asChild
          variant="outline"
          size="sm"
          className="h-7 text-[11px] gap-1.5 bg-white/[0.06] hover:bg-white/[0.14] text-white border-white/[0.18]"
        >
          <Link to={`/projects/${projectId}/runs?agent=functional`}>
            <History className="w-3.5 h-3.5" /> {t("Past Runs")}
            {runCount > 0 && (
              <Badge className="h-4 px-1 text-[9px] bg-white/[0.15] text-white border-0 ml-0.5">
                {runCount}
              </Badge>
            )}
          </Link>
        </Button>
      }
    />
  );
}
